import keyMirror from 'keymirror';

export const studySongActionTypes = keyMirror({
	GENERATE_SONG_REQUEST: null,
	GENERATE_SONG_SUCCESS: null,
	GENERATE_SONG_ERROR: null,

	CLEAR_AI_SONG_STATE: null,

	GET_SONG_DETAILS_REQUEST: null,
	GET_SONG_DETAILS_SUCCESS: null,
	GET_SONG_DETAILS_ERROR: null,

	FAVORITE_UNFAVORITE_SONG_REQUEST: null,
	FAVORITE_UNFAVORITE_SONG_SUCCESS: null,
	FAVORITE_UNFAVORITE_SONG_ERROR: null,
});

export const getSelectedWords = (selectedItems, localePosition) => {
	const items = [...selectedItems];
	return items.slice(0, 10).map((el) => el[localePosition]);
};

export const SONG_BG_COLOR = '#2f0f53';
